import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Loader/loader/loader.component';
import { CommonService } from '../../Model/Common/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { EMPTY_OBSERVER } from 'rxjs/internal/Subscriber';

@Component({
  selector: 'app-employee-list-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, DataTablesModule, RouterOutlet, RouterModule],
  templateUrl: './employee-list-popup.component.html',
  styleUrl: './employee-list-popup.component.scss'
})
export class EmployeeListPopupComponent {
  isDisabled: boolean = false;
  EmpData = [] as any;
  Filter = {
    Empcode: null,
    EmpName: null,
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private activeModal: NgbActiveModal,
    private combo: ComboService,
    private toast: ToastService,
    private router: Router,
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.Filter.Empcode != null || this.Filter.EmpName != null) {
        this.ComboLoad('FilterOnEmpCodeName');
      } else {
        this.toast.show({ message: 'Please enter employee code or employee name', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype,'EmpCode':this.Filter.Empcode,'EmpName':this.Filter.EmpName }).subscribe({
      next: (response) => {
        if (Combotype == 'FilterOnEmpCodeName') {
          this.EmpData = response.ComboLoad;
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(result: boolean) {
    this.activeModal.close(result);
  }

  OpenDeclarionInvestment(Type: string, EmpMasterID: number) {
    this.activeModal.close();
    if (Type == 'D') {
      this.router.navigate(['/incometax/incometax/add/d/e/' + EmpMasterID]);
    }else if (Type == 'E') {
      this.router.navigate(['/incometax/incometax/add/e/e/' + EmpMasterID]);
    }

  }
}
